import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ExternalchangepasswordService } from './Service/externalchangepassword.service';
import { ChangePassword } from './Model/externalchangepassword';
import { authManager } from '@authmanager/authManager';
import { AdminService } from '@adminservice/admin.service';
import { environment } from '@environment/environment';
import { GetEnvVarService } from "../service/get-env-var.service";

@Component({
  selector: 'app-externalchangepassword',
  templateUrl: './externalchangepassword.component.html',
  styleUrls: ['./externalchangepassword.component.css'],
  providers: [ExternalchangepasswordService]
})
export class ExternalChangePassword implements OnInit {
  ChangePassword: any;
  userID: number;
  password: string;
  newPassword: string;
  confirmPassword: string;
  PasswordDetails: any = {};
  showlabel: boolean;
  showConfirmErrorMsg: boolean;
  passwordPattern: string;
  patternInValid: boolean;
  oldPassWordInvalid: boolean;
  newPasswordInvalid: boolean;
  oldPasswordRequired: boolean;
  newPasswordRequired: boolean;
  confirmPasswordRequired: boolean;
  userFirstName: string;
  userLastName: string;
  LognewUser: any = {};
  isHidden: boolean;
  showPassword: boolean;
  showNewPassword: boolean;
  showConfirmPassword: boolean;

  constructor(private adminService: AdminService, private router: Router, private externalchangepasswordService: ExternalchangepasswordService, private getEnvVarService: GetEnvVarService) {
    this.isHidden = false;
    this.passwordPattern = '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$#~$!@])[A-Za-z\d$#~$!@].{11,}';
    this.showPassword = false;
    this.showNewPassword = false;
    this.showConfirmPassword = false;
  }

  ngOnInit() {
    this.showlabel = true;
    this.showConfirmErrorMsg = false;
    this.patternInValid = false;
    this.oldPassWordInvalid = false;
    this.newPasswordInvalid = false;
    this.oldPasswordRequired = false;
    this.newPasswordRequired = false;
    this.confirmPasswordRequired = false;
    this.userFirstName = sessionStorage.getItem('firstname');
    this.userLastName = sessionStorage.getItem('lastname');

    // To hide cancel button
    if (this.router.url === //environment.ChangePasswordOnForgotPassword
      this.getEnvVarService.getChangePasswordOnForgotPassword()) {
      this.isHidden = false;
    } else {
      this.isHidden = true;
    }

  }


  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }
  toggleShowNewPassword() {
    this.showNewPassword = !this.showNewPassword;
  }
  toggleShowConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }


  Passwordsubmit(myForm) {
    this.PasswordDetails.UserID = Number(sessionStorage.getItem('userid'));
    this.PasswordDetails.oldPassword = this.password;

    this.PasswordDetails.newPassword = this.newPassword;
    if (myForm.valid) {
      if (this.showConfirmErrorMsg === false
        && this.patternInValid === false
        && this.oldPassWordInvalid === false
        && this.newPasswordInvalid === false) {
        if (this.newPassword !== '' && this.newPassword !== undefined) {
          this.externalchangepasswordService.isPasswordExists(this.PasswordDetails.UserID, this.PasswordDetails.oldPassword).subscribe(
            oldPasswordResponse => {
              //console.log(oldPasswordResponse);
              if (oldPasswordResponse) {
                this.externalchangepasswordService.isPasswordExists(this.PasswordDetails.UserID, this.PasswordDetails.newPassword).subscribe(
                  newPasswordResponse => {
                    if (!newPasswordResponse) {
                      this.externalchangepasswordService.postPasswordDetails(this.PasswordDetails).subscribe(
                        passwordResponse => {
                          this.logoutUser();
                        }
                      );

                    } else {
                      this.newPasswordInvalid = true;
                    }
                  });
              } else {
                this.oldPassWordInvalid = true;
              }
            }
          );
        }
      }

    } else {
      if (myForm.controls.OldPassword.valid) {
        this.oldPasswordRequired = false;
      } else {
        this.oldPasswordRequired = true;
      }
      if (myForm.controls.NewPassword.valid) {
        this.newPasswordRequired = false;
      } else {
        if (this.newPassword === '' || this.newPassword === undefined) {
          this.newPasswordRequired = true;
        } else {
          this.newPasswordRequired = false;
        }
      }
      if (myForm.controls.ConfirmPassword.valid) {
        this.confirmPasswordRequired = false;
      } else {
        this.confirmPasswordRequired = true;
      }
    }
  }

  ConfirmPasswordCheck(type: string) {
    if (this.newPassword !== '' && this.confirmPassword !== '' && this.newPassword !== undefined && this.confirmPassword !== undefined) {
      if (this.newPassword === this.confirmPassword) {
        this.showConfirmErrorMsg = false;
      } else {
        this.showConfirmErrorMsg = true;
      }
    }
    if (this.newPassword === '' || this.newPassword === undefined) {
      this.showConfirmErrorMsg = false;
    }
    if (type === 'new') {
      this.newPasswordInvalid = false;
      if (this.newPassword !== '' && this.newPassword !== undefined) {
        this.newPasswordRequired = false;
      }
    } else if (type === 'confirm') {
      if (this.confirmPassword === '' || this.confirmPassword === undefined) {
        this.showConfirmErrorMsg = false;
      } else {
        this.confirmPasswordRequired = false;
      }
    } else {
      if (this.confirmPassword !== '' && this.confirmPassword !== undefined) {

        this.confirmPasswordRequired = false;
      }
    }

  }

  PatternCheck(myForm) {
    if (!myForm.controls.NewPassword.valid) {
      this.patternInValid = true;
    } else {
      this.patternInValid = false;
    }
    if (this.newPassword === '' || this.newPassword === undefined) {
      this.patternInValid = false;
    } else {
      let res = this.newPassword.match(this.passwordPattern);

      if (res != null) {
        this.patternInValid = false;
      } else {
        this.patternInValid = true;
      }

      let lowercaseNewPassword = this.newPassword.toLowerCase();
      if (this.userFirstName !== null && this.userFirstName !== undefined && this.userFirstName !== '') {
        if (lowercaseNewPassword.indexOf(this.userFirstName.toLowerCase()) > -1) {
          this.patternInValid = true;
        }
      }
      if (this.userLastName !== null && this.userLastName !== undefined && this.userLastName !== '') {
        if (lowercaseNewPassword.indexOf(this.userLastName.toLowerCase()) > -1) {
          this.patternInValid = true;
        }
      }

    }
  }

  ClearValidation() {
    this.oldPassWordInvalid = false;
    if (this.password !== '' && this.password !== undefined) {
      this.oldPasswordRequired = false;
    }
  }

  logoutUser() {
    this.LognewUser.LogOutTime = new Date();
    this.LognewUser.Active = 0;
    // Method to store user's logout details
    this.adminService.LogUserUpdateDetails(this.LognewUser)
      .subscribe((status) => {
        this.router.navigate(['Login']);
      });
  }

  OnBack() {
    this.router.navigate(['Invoice']);
  }
}



// WEBPACK FOOTER //
// ./src/app/externalchangepassword/externalchangepassword.component.ts